import type { UesConfig } from "../entities/ues-config"
import type { KnowledgeBaseRepository } from "../repositories/knowledge-base-repository"

export const makeUpdateKbUesConfig = (repo: KnowledgeBaseRepository) =>
  (kbId: string, config: UesConfig) =>
    repo.putUesConfig(kbId, config)
